<template>
	<div class="login-page flex-row align-items-center">
    <div class="container">
			<div class="row justify-content-center">
				<div class="col-md-10">
					<div class="card-group">
						<div class="card">
							<div class="login-page__background"></div>
							<div class="login-page__form card-body">
								<form class="form-login"  @submit.prevent="checkCredentials">
									<h2 class="form-login__title mb-4">Авторизация</h2>
									<div class="form-group input-group-lg">
										<input class="form-control" ref="login" name="login" placeholder="Адрес электронной почты" type="text" v-model="login">
									</div>
									<div class="form-group input-group-lg">
										<input class="form-control" ref="password" name="password" placeholder="Пароль" type="password" v-model="password">
									</div>
									<b-alert show v-if="error" variant="danger">{{error}}</b-alert>
									<b-button type="submit" variant="primary" class="button is-primary btn-lg" v-bind:class="{'loading': loading}">Войти</b-button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data: function (router) {
		return {
			login: '',
			password: '',
			error: '',
			loading: false
		}
	},
	methods: {
		checkCredentials: function () {
			var store = this.$store

			if (this.login === '') {
				this.$refs.login.focus()
				return false
			}
			if (this.password === '') {
				this.$refs.password.focus()
				return false
			}
			this.loading = true
			this.resetResponse()
			this.$http.post(store.state.apiURL + '/v1/oauth/token', {login: this.login, password: this.password}, {
				emulateHTTP: true
			}).then((response) => {
				this.loading = false
				let data = response.body.data
				let userAuth = {
					access_token: data.access_token,
					expires_in: data.expires_in,
					token_type: data.token_type,
					refresh_token: data.refresh_token,
					refreshed_at: parseInt(new Date().getTime() / 1000)
				}
				store.commit('SET_USER', data.user)
				store.commit('SET_USER_AUTH', userAuth)
				// Save to local storage as well
				if (window.localStorage) {
					window.localStorage.setItem('user', JSON.stringify(data.user))
					window.localStorage.setItem('user_auth', JSON.stringify(userAuth))
				}
				store.dispatch('notificaition/sync')
				location.reload()
			}, (response) => {
				this.loading = false
				this.error = response.body.message
				store.commit('TOGGLE_LOADING')
			})
		},
		resetResponse: function () {
			this.error = ''
		}
	}
}
</script>
<style lang="scss">
.login-page {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	min-height: 100vh;
	.card, .form-control, .btn, .alert {
		border-radius: 0 !important;
	}
	.login-page__background {
		background-image: url(/static/img/login-background.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100%;
    position: absolute;
    width: 50%;
	}
	.login-page__form {
		width: 50%;
		justify-content: flex-end;
		margin-left: auto;
		min-height: 400px;
		padding: 3rem;
	}
}

.form-login {
	.form-login__title {
		text-align: center;
		font-weight: 100;
	}
	button {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/user/account/login.vue